export default __webpack_public_path__ + "6337afe5408ea62f62e7aba6037b1577.png";